import { withStyles } from '@material-ui/core';

const styles = () => ({
  container: {
    height: '100%',
  },
});

export default withStyles(styles);
